import React, { useState } from 'react';
import { addSupplierBlog } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddSupplierBlogModal = props => {
  const [title, setTitle] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    supplierId,
    toggleModal,
    onSuccess,
  } = props;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await addSupplierBlog({
        id: supplierId,
        link,
        title,
      });
      onSuccess(response.toJSON());
      showSuccess('Blog added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Supplier</div>
            <div className={styles['modal-title']}>Add Blog</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={'mb-3'}>
            <div className={styles['label']}>Title</div>
            <input
              className={'form-control'}
              value={title}
              onChange={e => setTitle(e.target.value)}
              disabled={loading}
            />
          </div>
          <div>
            <div className={styles['label']}>Link</div>
            <input
              className={'form-control'}
              value={link}
              onChange={e => setLink(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            type={'button'}
            disabled={loading}
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            className={styles['submit-button']}
            type={'submit'}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddSupplierBlogModal;